import { render, staticRenderFns } from "./AccountsBalance.vue?vue&type=template&id=a82c93c8&"
import script from "./AccountsBalance.vue?vue&type=script&lang=js&"
export * from "./AccountsBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports